import styled from 'styled-components';
import { AutoAwesomeOutlined } from '@mui/icons-material';
import { IContainerStylesProps } from './types';

export const Container = styled.div<IContainerStylesProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: ${({ paddingLeft }) => paddingLeft}px;
`;

export const WrapperContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 1100px;
  gap: 20px;
  margin-top: 20px;
  padding: 20px;
`;

export const WrapperTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const IconAi = styled(AutoAwesomeOutlined).attrs({
  htmlColor: '#226A43',
  fontSize: 'large',
})``;

export const Title = styled.p`
  color: #226a43;
  font-weight: 700;
  font-size: 32px;
  margin: 0;
`;

export const WrapperSuggestions = styled.div`
  display: flex;
  align-items: center;
  padding: 30px;
  border-radius: 30px;
  background: #fff;
  flex-direction: column;
  gap: 20px;
`;
export const TitleSuggestions = styled.p`
  color: #1e1e1e;
  font-weight: 700;
  font-size: 20px;
  margin: 0;
`;

export const WrapperCardsSuggestions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
`;

export const CardsSuggestions = styled.button`
  border-radius: 26px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #fafafa;
  padding: 20px;
  cursor: pointer;
  border: none;
  margin: 0;
`;
export const TitleCardsSuggestions = styled.p`
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  padding: 0;
`;
